import React from 'react';
import './Awards.css';

import { Heading } from '../../../components';
import { awards } from '../../../constants';



const Awards = () => {

  return (

    <section className="awards">

      {/* Section heading */}
      <Heading title={'Our Achievements'} subTitle={'Trusted in Solar Excellence'} />

      <div className='box-container'>

        {/* Map over the awards array to render each award image */}
        {awards.map((award, index) => {
            return (
              /* Render the award image */
              <div className='award-item' key={index}><img src={award} alt='Award' /></div>
            )
          })
        }

      </div>

    </section>

  );
}

export default Awards;